import React, {MutableRefObject, useCallback, useEffect, useState} from 'react'
import {createPortal, findDOMNode} from 'react-dom'

import {MentionOption} from "./option"
import Popover from "../../../gd-popover/popover-v2"
import PopoverPosition from "../../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../gd-popover/@const"
import EntitySelector from "../../../entity-selector/selector"
import {EntitySelectorEntityType, EntitySelectorMode} from "../../../entity-selector/@const"
import {EntitySelectorSettings} from "../../editor";

const debug = false
// const debug = "MentionsMenu"

export function MentionsMenu (
    anchorElementRef        : MutableRefObject<HTMLElement | null>,
    itemProps               : {
        selectedIndex           : number | null
        selectOptionAndCleanUp  : (option: MentionOption) => void
        setHighlightedIndex     : (index: number) => void
        options                 : Array<MentionOption>
    },
    matchingString          : string | null,
    mentions?               : any,
    projectId?              : ID,
    entitySelectorSettings? : EntitySelectorSettings
) {
    debug && console.log(debug, 'render', anchorElementRef.current, mentions.length)

    const [isHidden, setIsHidden] = useState(false)

    useEffect(() => {
        debug && console.log(debug, 'useEffect anchorElementRef.current', anchorElementRef.current)
        setIsHidden(false)
    }, [anchorElementRef]);

    const onEntitySelected = useCallback((entity:MentionOption)=>{
        itemProps.selectOptionAndCleanUp(entity)
    }, [])

    const onClickOutside = useCallback((e:any)=>{
        debug && console.log(debug, 'onClickOutside', e)
        setIsHidden(true)
    }, [])

    const onPopoverHide = useCallback(()=>{
        if (anchorElementRef.current) {
            gd.utils.Dom.removeClass(anchorElementRef.current,"visible")
        }

        delete entitySelectorSettings?.entityType
    }, [])

    if (!anchorElementRef.current || isHidden) return null

    if (anchorElementRef.current) {
        gd.utils.Dom.addClass(anchorElementRef.current,"visible")
    }

    const popoverPosition = new PopoverPosition({
        attachment      : "bottom left",
        targetAttachment: "top left",
        attachmentType  : PopoverAttachmentType.HORIZONTAL,
    })

    return createPortal(
        <Popover
            position            = {popoverPosition}
            onClickOutside      = {onClickOutside}
            onPopoverHide       = {onPopoverHide}
            getTargetFunc       = {()=>findDOMNode(anchorElementRef.current)}
        >
            <EntitySelector
                mode                = {EntitySelectorMode.POPOVER}
                userMentions        = {mentions}
                projectId           = {projectId}
                initialEntityType   = {entitySelectorSettings?.entityType}
                excludedEntityTypes = {[EntitySelectorEntityType.MEETING]}
                onEntitySelected    = {onEntitySelected}
            />
        </Popover>,
        anchorElementRef.current,
    )
}
